import { render, staticRenderFns } from "./TaskHeader.vue?vue&type=template&id=13f6a690&scoped=true&"
import script from "./TaskHeader.vue?vue&type=script&lang=js&"
export * from "./TaskHeader.vue?vue&type=script&lang=js&"
import style0 from "./TaskHeader.vue?vue&type=style&index=0&id=13f6a690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f6a690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VList,VRow})
